
import { useState, useEffect } from "react";
import { supabaseCustomRole } from "@/lib/supabase/customRoleClient";

export interface Rating {
  id: string;
  user_id: string;
  dealer_id: string;
  rating: number;
  comment: string;
  created_at: string;
  user_name?: string; // Optional user display name
}

export function useDealerRatings(dealerId: string) {
  const [ratings, setRatings] = useState<Rating[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRatings = async () => {
      try {
        setIsLoading(true);
        console.log("Fetching ratings for dealer ID:", dealerId);
        
        // Use the vw_dealers_with_ratings view instead of direct table access
        // This view already includes the average rating but we need to get individual ratings separately
        const { data: dealerWithRatings, error: dealerError } = await supabaseCustomRole
          .from('vw_dealers_with_ratings')
          .select('*')
          .eq('id', dealerId)
          .single();
          
        if (dealerError) {
          console.error("Error fetching dealer with ratings:", dealerError);
          throw dealerError;
        }
        
        console.log("Dealer with ratings data:", dealerWithRatings);
        
        // Now fetch individual ratings for this dealer
        // Still need to query dealer_ratings table for individual ratings
        const { data: ratingsData, error: ratingsError } = await supabaseCustomRole
          .from('dealer_ratings')
          .select('*')
          .eq('dealer_id', dealerId)
          .order('created_at', { ascending: false });

        if (ratingsError) {
          console.error("Error fetching individual dealer ratings:", ratingsError);
          throw ratingsError;
        }

        console.log("Ratings data received:", ratingsData);

        // Transform the data to include any additional fields we might need
        const processedRatings = ratingsData?.map(rating => ({
          ...rating,
          // We can add any necessary fields here if needed
        })) || [];

        setRatings(processedRatings);
      } catch (error) {
        console.error('Errore durante il recupero delle recensioni:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRatings();
  }, [dealerId]);

  return { ratings, isLoading };
}
